import React,{useState,useEffect} from 'react'
import "./Restaurants.css";
import {IMG_CDN_URL} from "../utils/links/link";
import star from "../utils/star.svg";
import {Link} from "react-router-dom";
import RestaurantCard from './RestaurantCard/RestaurantCard';
import InfiniteScroll from "react-infinite-scroll-component"
import Shimmer from '../Shimmer/Shimmer';
import { AiFillStar } from 'react-icons/ai';
// const PAGE_NUMBER=1;
const Restaurants = () => {
    const [rest,setRest]=useState({})
    const [page,setpage]=useState(10);
    const [newdata,setNewdata]=useState({});
    
    
    useEffect(()=>{
    //    getRandNum();
        getRestaurants();
       loadmore();
     },[]);
     
     async function getRestaurants(){
        const data=await fetch(`https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.7040592&lng=77.10249019999999&offset=10&sortBy=RELEVANCE&pageType=SEE_ALL&page_type=DESKTOP_SEE_ALL_LISTING`);
        const json=await data.json();
        
        setRest({...rest,...json?.data?.cards})
        //console.log("KKK"+modifiedData)
        
        //setNewdata(json?.data)
     }
     
     async function loadmore(){
        // e.preventDefault()
        const data =await fetch(`https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.7040592&lng=77.10249019999999&offset=${page}&sortBy=RELEVANCE&pageType=SEE_ALL&page_type=DESKTOP_SEE_ALL_LISTING`);
        const json=await data.json();
       
        setRest({...rest,...json?.data?.cards})
     }

     window.addEventListener('scroll',()=>{
        if(window.scrollY+window.innerHeight>=document.documentElement.scrollHeight){
            let num=page+2;
          setpage(num);
          loadmore();
          
        }
     })

 
return !rest ?(
  <Shimmer/>
  ):(
      <div className="cardList" >
         {
            Object.values(rest).map((key)=>(
               <Link to={"/rcard/"+key.data.data.id} style={{textDecoration:"none"}} >
                <div className='Card'>
                    <div >
                        <img className='cardImg' src={IMG_CDN_URL+key.data.data.cloudinaryImageId} alt={key.data.id}/>
                    </div>
                    <div className="cardTitle">{key.data.data.name}</div>
                    <div className='cardInfo'>
                        <div className='Rating'>
                        <div className='Star'><AiFillStar/></div>
                        <div className='cardStar'>{key.data.data.avgRating}</div>
                        </div>
                        <div className='cardMin'>{key.data.data.slaString}</div>
                        <div className='cardrate'>{key.data.data.costForTwoString}</div>
                        
                    </div>
                    <div className='cardLine'></div>
                    {/* meta */}
                </div>
                </Link> 
            ))
            }
            </div>
        
      
  )
}

export default Restaurants


{/* <div>
                        {key.data.aggregatedDiscountInfoV2.descriptionList.map((k)=>{
                        <div className='cardOff'>
                            {k.meta}
                        </div>
                    })}
                    </div> */}
                    //https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.7040592&lng=77.10249019999999&sortBy=RELEVANCE&page_type=DESKTOP_WEB_LISTING
     //json?.data?.cards[2]?.data?.data?.cards